
import Navbar from "../../../components/navbar/Navbar"
import Sidebar from "../../../components/sidebar/Sidebar"
import "../../Patient/list.scss"
import AddUser from "./addUser"

const AddUserContainer = () => {


  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <AddUser  />
        </>
      </div>
    </div>
  )
}

export default AddUserContainer